import React, {Component} from "react";
import { Tabs } from 'antd';
import getSize from "../../../utils/getSize";
import NHFetch from "../../../utils/NHFetch";
import HjblcxTab from "../hjblcx/hjblcxTab"
import css from './index.css';
const TabPane = Tabs.TabPane;
const baseUrlPath = "/tjcx/hjblcx"; //基础路径

/**
 * 环节办理查询
 * @author Xiafanglin
 * @date 2018-03-19 14:29:32
 * Version: 1.0
 */
export default class HjblcxIndex extends Component {
    constructor(props) {
        super(props)
        this.state = {
            data:[],
            defaultActiveKey:undefined,
        }
    }
    
    componentWillMount() {
        this.getData();
    }
    //1.查询所有的流程定义
    getData = () => {
        NHFetch(baseUrlPath + '/getLcdyData' , 'GET')
        .then(res => {
            if (res) {
                this.setState({ data: res.data });
                if (res.data && res.data.length > 0) {
                    this.setState({ defaultActiveKey: res.data[0].PKID });
                }
            }
        })
    }
    //2.遍历数据
    loop = (data) => {
        return data.map((item) => {
            let lcdyid = item.PKID;
            // return <TabPane tab={item.lcmc} key={lcdyid}></TabPane>;
            return <TabPane tab={item.LCMC} key={lcdyid}><HjblcxTab initParams={{"S_lcid_EQ":lcdyid}} selectKey={lcdyid}/></TabPane>;

        });
    }

    render() {
        return(
            <div className={css.main_right_content} style={{height:getSize().windowH-123}}>
                <Tabs defaultActiveKey={this.state.defaultActiveKey}>
                    {this.loop(this.state.data)}
                </Tabs>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./components/tjcx/hjblcx/index.js